import { render, staticRenderFns } from "./MediaBlock.vue?vue&type=template&id=64cfa0d1&scoped=true&"
import script from "./MediaBlock.vue?vue&type=script&lang=ts&"
export * from "./MediaBlock.vue?vue&type=script&lang=ts&"
import style0 from "./MediaBlock.vue?vue&type=style&index=0&id=64cfa0d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfa0d1",
  null
  
)

export default component.exports